import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    OLPaper: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(12),
    },
    walletFormContent: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
    addTranslation: {
      alignSelf: "start",
      color: theme.gray500,
      padding: theme.spacing(6, 6, 6, 0),
      fontWeight: 500,
    },
    fullWidth: { width: "100% !important", maxWidth: "100% !important" },
    clearIconWidth: {
      width: "36px",
      display: "flex",
      justifyContent: "end",
    },
    zeroPadding: { padding: "0 !important" },
    TooltipWrapper: {
      display: "flex",
      flexWrap: "wrap",
      minWidth: 0,
      width: "100%",
    },
    tooltipIcon: {
      width: "24px",
      height: "24px",
      color: theme.gray500,
    },
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
    translationSection: {
      maxWidth: "100%",
      position: "relative",
      "&+&": {
        paddingTop: theme.spacing(12),
      },
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
    },
    SelectInput: {
      "& + &": {
        marginTop: theme.spacing(10),
        [theme.breakpoints.up("md")]: { marginTop: theme.spacing(6) },
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: "100%",
        width: "100%",
      },
    },
    displayColumn: { flexDirection: "column" },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    sectionHeader: {
      color: theme.gray800,
      display: "block",
      fontSize: "16px",
      fontWeight: 500,
    },
    conditionSection: {
      borderBottom: `1px solid ${theme.gray100}`,
      maxWidth: "100%",
      position: "relative",
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
      paddingBottom: theme.spacing(14),
      marginBottom: theme.spacing(14),
    },
    conditionWrapper: {
      alignItems: "flex-start",
      display: "flex",
      justifyContent: "space-between",
    },
    headerText: {
      display: "block",
      fontSize: 18,
      marginBottom: theme.spacing(6),
    },
    detailsItem: {
      display: "flex",
      flexDirection: "column",
    },
    smallText: {
      color: theme.gray400,
      fontSize: 13,
      lineHeight: theme.spacing(8),
    },
    largeText: {
      color: theme.gray800,
      fontSize: 16,
      lineHeight: theme.spacing(10),
    },
    fieldDescription: {
      color: theme.gray500,
      fontSize: "14px",
    },
    warnIcon: {
      color: theme.orange500,
    },
    separator: {
      width: "100%",
      background: theme.gray100,
      height: "1px",
      margin: theme.spacing(12, 0),
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
    },
    toggleWrapper: {
      margin: theme.spacing(6, 0, 0, -4),
    },
    negativeDesc: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.gray500,
    },
    link: { fontSize: 14, fontWeight: 500 },
    annualExpirationDesc: {
      color: theme.gray500,
      fontWeight: 400,
      fontSize: 14,
    },
    annualExpirationDescWrapper: {
      paddingTop: theme.spacing(6),
      paddingLeft: theme.spacing(10),
    },
  }),
);
